<app-dialog
  [title]="'Shipping with'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Confirm',
      spin: spin
    }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <div class="pt-3" *ngIf="shippingList.length">
    <ul class="list-value">
      <li *ngFor="let order of shippingList">
        <div class="list-value_box">
          <div class="mat-checkbox-default primary">
            <mat-checkbox class="mat-checkbox" (change)="onCheckboxChange(order)"></mat-checkbox>
          </div>
          <div class="shipping-product-shiped-img">
            <img [src]="order.imageUrl" alt="" class="img-fluid h-100" />
          </div>
          <strong>{{
            (order?.shipmentCost || 0) + (order?.otherCost || 0) | currency
          }}</strong>
        </div>
      </li>
    </ul>
  </div>
</app-dialog>
